// extracted by mini-css-extract-plugin
export var actions = "_bw-d";
export var benefitCard = "_bw-a";
export var benefitIcon = "_bw-b";
export var benefitLabel = "_bw-c";
export var benefits = "_bw-9";
export var bodyText = "_bw-8";
export var closeButton = "_bw-2";
export var content = "_bw-3";
export var eyebrow = "_bw-4";
export var heading = "_bw-5";
export var image = "_bw-f";
export var imagePanel = "_bw-e";
export var modal = "_bw-0";
export var shell = "_bw-1";
export var title = "_bw-6";
export var titleOffer = "_bw-7";